<template>
	<div class="layer-project" data-project-name="serveOne">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">Serveone</h1>
					<a href="http://www.serveonemicro.co.kr" class="link" target="_blank"
						>www.serveonemicro.co.kr</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						서브원은 2002년 LG유통에서 분리하여 LG MRO로 출범 후 2005년
						서브원으로 사명을 변경하고 <br />MRO, 건물/부동산 관리, 건설, 레저
						분야로 사업을 확대하며 매년 비약적인 성장을 거듭하고 있는
						기업입니다. <br />각 사업부 콘텐츠 및 영업 담당자의 모바일 명함을
						<span class="ib">e-mail</span>/SMS/카카오톡으로 공유 할 수 있도록
						개발하여 영업 지원용 시스템으로 활용하도록 구성하였습니다.
					</p>
					<div class="project-overview-diagram clfix">
						<div class="diagram01">
							<strong>전략적 아웃소싱 서비스</strong>
							<ul>
								<li class="item01">MRO</li>
								<li class="item02">FM</li>
								<li class="item03">Cont.</li>
							</ul>
						</div>
						<p class="diagram02">Vision</p>
						<div class="diagram03">
							<strong>프리미엄 레저 서비스</strong>
							<ul>
								<li class="item01">RESORT</li>
								<li class="item02">GC</li>
							</ul>
						</div>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section full section01">
				<div class="inner-section">
					<div class="mobile-web-info">
						<strong class="project-subtit">Mobile Web</strong>
						<p class="sub-text">
							서브원의 사업분야를 한 눈에 보기 쉽도록 구성하여 사용자에게
							서브원의 사업내용과 이미지를
							<span class="ib">함께 제공하도록 구성했습니다.</span>
						</p>
					</div>
					<div class="mobile-web-slider swiper-container">
						<ul class="swiper-wrapper clfix">
							<li class="swiper-slide item01">
								<div class="img">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/serveone/mobile-web-img-01@m.png"
									/>
								</div>
								<span>MRO</span>
							</li>
							<li class="swiper-slide item02">
								<div class="img">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/serveone/mobile-web-img-02@m.png"
									/>
								</div>
								<span>FM</span>
							</li>
							<li class="swiper-slide item03">
								<div class="img">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/serveone/mobile-web-img-03@m.png"
									/>
								</div>
								<span>Cont.</span>
							</li>
						</ul>

						<!-- Add Pagination -->
						<div class="swiper-pagination mobile-web-pagination"></div>
					</div>
				</div>
			</section>

			<section class="section section02">
				<div class="inner-section">
					<div class="item01">
						<div class="img">
							<img
								src="/static/img/project-detail/serveone/mobile-img-01@m.png"
								alt=""
							/>
						</div>
					</div>
					<div class="item02">
						<div class="img">
							<img
								src="/static/img/project-detail/serveone/mobile-img-02@m.png"
								alt=""
							/>
						</div>
					</div>
					<div class="item03">
						<div class="img">
							<img
								src="/static/img/project-detail/serveone/mobile-img-03@m.png"
								alt=""
							/>
						</div>
					</div>
					<div class="item04">
						<div class="img">
							<img
								src="/static/img/project-detail/serveone/mobile-img-04@m.png"
								alt=""
							/>
						</div>
					</div>
					<div class="item05">
						<div class="img">
							<img
								src="/static/img/project-detail/serveone/mobile-img-05@m.png"
								alt=""
							/>
						</div>
					</div>
					<div class="item06">
						<div class="img">
							<img
								src="/static/img/project-detail/serveone/mobile-img-06@m.png"
								alt=""
							/>
						</div>
					</div>
				</div>
			</section>

			<section class="section section03">
				<div class="inner-section">
					<strong class="project-subtit">Layout</strong>
					<p class="sub-text">
						서브원의 소개 및 사업내용을 사용자가 <br />모바일에서 편리하게 확인
						및 이동할 수 있도록 <br />모바일 환경에 맞게 UI/UX를 구성하였습니다.
					</p>
				</div>
			</section>

			<section class="section section04">
				<div class="inner-section">
					<strong class="project-subtit">Wireframe</strong>
					<div class="wireframe-img-area">
						<div class="item01">
							<span class="img-title">Main</span>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/serveone/wireframe-img-01@m.png"
								/>
							</div>
						</div>
						<div class="item02">
							<span class="img-title">Menu</span>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/serveone/wireframe-img-02@m.png"
								/>
							</div>
						</div>
						<div class="item03">
							<span class="img-title">Sub_비즈니스 소개</span>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/serveone/wireframe-img-03@m.png"
								/>
							</div>
						</div>
						<div class="item04">
							<span class="img-title">Sub_비즈니스 소개</span>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/serveone/wireframe-img-04@m.png"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="section section05">
				<div class="inner-section">
					<div class="point-color-area">
						<div class="color01">
							<span>#282a2c</span>
						</div>
						<div class="color02">
							<span>#555555</span>
						</div>
						<div class="color03">
							<span>#b7c1ce</span>
						</div>
						<div class="color04">
							<span>#ffffff</span>
						</div>
						<div class="color05">
							<span>#a40033</span>
						</div>
						<div class="color06">
							<span>#9e8366</span>
						</div>
					</div>
					<div class="point-font-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/serveone/point-font-img@m.png"
							/>
						</div>
					</div>
					<div class="point-icon-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/serveone/point-icon-img@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">Serveone</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var mobilewebSwiper;

		var mobileWeb = function () {
			if (isSlider) {
				isSlider = false;
				mobilewebSwiper = new Swiper(".mobile-web-slider", {
					spaceBetween: 30,
					centeredSlides: true,
					pagination: {
						el: ".mobile-web-pagination",
						clickable: true,
					},
				});
			}
		};

		winW = $window.outerWidth();
		if (winW < 712) {
			mobileWeb();
		} else {
			isSlider = true;
		}
		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					mobileWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					mobilewebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
	methods: {},
};
</script>
<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
.img {
	text-align: center;
}
.project-tit {
	text-transform: uppercase;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
	.layer-project {
		font-size: 1.6rem;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: #282a2c url(/static/img/project-detail/serveone/ci.png) 50% / auto
		34px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/serveone/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/serveone/bg-overview@t.jpg);
	}
	.project-client {
		background-size: auto 41px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/serveone/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 62px;
	}
}

/* Overview */
.project-overview {
	background-color: #a40033;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 30px;
}
.project-overview-diagram {
	text-align: center;
}
.project-overview-diagram ul {
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.project-overview-diagram ul:before {
	content: "";
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	height: 1px;
	background-color: #9e8366;
}
.project-overview-diagram li {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 90px;
	height: 90px;
	background-color: #9e8366;
	border-radius: 50%;
}
.project-overview-diagram strong {
	display: block;
	margin-bottom: 15px;
	font-weight: 500;
}
.project-overview-diagram .diagram01 {
	margin-bottom: 20px;
}
.project-overview-diagram .diagram02 {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 160px;
	height: 160px;
	margin: 0 auto 20px;
	border: 2px solid #9e8366;
	border-radius: 50%;
	font-size: 1.8rem;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.project-overview-txt {
		margin-bottom: 35px;
	}
	.project-overview-diagram {
		max-width: 632px;
		margin: 0 auto;
	}
	.project-overview-diagram .diagram01,
	.project-overview-diagram .diagram02,
	.project-overview-diagram .diagram03 {
		float: left;
	}
	.project-overview-diagram .diagram02,
	.project-overview-diagram .diagram03 {
		margin-left: -20px;
	}
	.project-overview-diagram li + li {
		margin-left: 20px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding-bottom: 25px;
	}
	.project-overview-txt {
		margin-bottom: 90px;
	}
	.project-overview-diagram {
		max-width: 1240px;
		margin: 0 auto;
	}
	.project-overview-diagram .diagram02,
	.project-overview-diagram .diagram03 {
		margin-left: -25px;
	}
	.project-overview-diagram li {
		width: 170px;
		height: 170px;
		font-size: 20px;
	}
	.project-overview-diagram li + li {
		margin-left: 40px;
	}
	.project-overview-diagram .diagram02 {
		width: 320px;
		height: 320px;
		border-width: 4px;
		font-size: 30px;
	}
	.project-overview-diagram strong {
		margin-top: 30px;
		margin-bottom: 20px;
		font-size: 20px;
	}
}

.mobile-web-info {
	padding: 0 15px;
}
.mobile-web-slider li {
	text-align: center;
}
.mobile-web-slider li span {
	display: block;
	margin-top: 21px;
}
.mobile-web-slider img {
	border-radius: 14px;
	box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.28);
}
@media screen and (max-width: 711px) {
	.mobile-web-slider {
		padding: 35px 78px 40px;
	}
	.mobile-web-slider li {
		opacity: 0.3;
		transition: opacity 0.3s ease-in-out;
	}
	.mobile-web-slider .swiper-slide-active {
		opacity: 1;
	}
}
@media screen and (min-width: 712px) {
	.section01 .inner-section {
		padding-bottom: 10px;
	}
	.mobile-web-info {
		padding: 0 40px;
	}
	.mobile-web-slider {
		padding: 35px 40px 0;
	}
	.mobile-web-slider .swiper-wrapper {
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.mobile-web-slider li {
		width: 23.17415vw;
	}
	.mobile-web-slider li + li {
		margin-left: 7.5505vw;
	}
}
@media screen and (min-width: 1280px) {
	.section01 .inner-section {
		padding-top: 60px;
		padding-bottom: 60px;
	}
	.mobile-web-info {
		max-width: 1280px;
		margin: 0 auto;
		padding: 0 20px;
	}
	.mobile-web-slider {
		padding: 60px 0 0;
	}
	.mobile-web-slider .swiper-wrapper {
		justify-content: center;
	}
	.mobile-web-slider li {
		width: 366px;
	}
	.mobile-web-slider li + li {
		margin-left: 70px;
	}
	.mobile-web-slider li span {
		margin-top: 40px;
		font-size: 18px;
	}
	.mobile-web-slider img {
		border-radius: 32px;
	}
}
.section.section02 {
	padding-top: 35px;
	padding-bottom: 45px;
	background-color: #f3f3f3;
}
.section02 .inner-section {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.section02 .inner-section > div {
	margin-bottom: 20px;
}
.section02 .inner-section .img {
	width: 41.875vw;
}
.section02 .inner-section img {
	border-radius: 10px;
	box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.4);
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section02 .inner-section {
		justify-content: center;
		padding-top: 15px;
	}
	.section02 .inner-section > div {
		margin: 0 25px 35px;
	}
	.section02 .inner-section .img {
		width: 18.892022vw;
	}
}
@media screen and (min-width: 1280px) {
	.section.section02 {
		padding-bottom: 20px;
	}
	.section02 .inner-section {
		padding-top: 96px;
	}
	.section02 .inner-section > div {
		margin: 0 47px 70px;
	}
	.section02 .inner-section .img {
		width: 268px;
	}
	.section02 .inner-section img {
		border-radius: 20px;
	}
}
.section03 {
	height: 138.4375vw;
	color: #fff;
	background: #211b19 url(/static/img/project-detail/serveone/layout-bg@m.png)
		no-repeat;
	background-size: cover;
}
.section03 .sub-text {
	word-break: keep-all;
}
@media screen and (max-width: 711px) {
	.section03 .sub-text {
		max-width: 340px;
	}
}
@media screen and (min-width: 712px) {
	.section03 {
		height: 58.0056vw;
		background-image: url(/static/img/project-detail/serveone/layout-bg@t.png);
	}
	.section03 .inner-section {
		padding-top: 10px;
	}
	.section03 .sub-text {
		width: 285px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 {
		height: 700px;
		background-image: url(/static/img/project-detail/serveone/layout-bg@w.png);
		background-position-x: 50%;
	}
	.section03 .inner-section {
		padding-top: 100px;
	}
	.section03 .sub-text {
		width: 390px;
	}
}
.section04 {
	background-color: #f2f2f2;
}
.section04 .inner-section {
	padding-top: 15px;
}
.wireframe-img-area {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.wireframe-img-area > div {
	width: 37.65625vw;
}
.wireframe-img-area .img-title {
	display: block;
	margin-bottom: 13px;
	font-weight: 500;
	color: #999;
}
@media screen and (max-width: 711px) {
	.wireframe-img-area > div {
		margin-bottom: 30px;
	}
}
@media screen and (min-width: 712px) {
	.section.section04 {
		padding-bottom: 0;
	}
	.section04 .inner-section {
		padding-top: 0;
	}
	.wireframe-img-area > div {
		width: 16.9241vw;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .inner-section {
		padding-top: 45px;
	}
	.section04 .project-subtit {
		margin-bottom: 60px;
	}
	.wireframe-img-area > div {
		width: 239px;
	}
	.wireframe-img-area .img-title {
		font-size: 24px;
	}
}

.point-color-area {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin-bottom: 35px;
}
.point-color-area > div {
	position: relative;
	width: 71px;
	margin-bottom: 20px;
	padding-top: 24.375vw;
	border-radius: 5px;
	box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.4);
}
.point-color-area > div:before {
	content: "";
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 24.375vw;
	border-top-left-radius: 5px;
	border-top-right-radius: 5px;
}
.point-color-area .color01:before {
	background-color: #282a2c;
}
.point-color-area .color02:before {
	background-color: #555;
}
.point-color-area .color03:before {
	background-color: #b7c1ce;
}
.point-color-area .color04:before {
	background-color: #fff;
	border-bottom: 1px solid #ddd;
}
.point-color-area .color05:before {
	background-color: #a40033;
}
.point-color-area .color06:before {
	background-color: #9e8366;
}
.point-color-area > div span {
	display: block;
	padding: 10px;
	font-size: 12px;
	text-align: center;
}
.point-font-area {
	margin-bottom: 45px;
}
.point-font-area .img {
	width: 88.59375vw;
}
@media screen and (max-width: 711px) {
	.section.section05 {
		padding: 40px 0;
	}
	.point-color-area,
	.point-font-area,
	.point-icon-area {
		padding: 0 15px;
	}
	.point-color-area > div {
		width: 22.18vw;
	}
	.point-color-area .color02,
	.point-color-area .color05 {
		margin-left: 4vw;
		margin-right: 4vw;
	}
}
@media screen and (min-width: 712px) {
	.section05 .inner-section {
		padding-top: 10px;
	}
	.point-color-area {
		width: 71.4887vw;
		margin: 0 auto 45px;
	}
	.point-color-area > div {
		width: 8.42vw;
		padding-top: 9.129vw;
	}
	.point-color-area > div:before {
		height: 9.129vw;
	}
	.point-font-area {
		width: 71.4887vw;
		margin: 0 auto 30px;
	}
	.point-font-area .img {
		width: 51.3342vw;
	}
	.point-icon-area .img {
		width: 71.4887vw;
		margin: 0 auto;
	}
}
@media screen and (min-width: 1280px) {
	.section05 .inner-section {
		padding-top: 80px;
		padding-bottom: 60px;
	}
	.point-color-area {
		width: 1044px;
		margin-bottom: 74px;
	}
	.point-color-area > div {
		width: 108px;
		margin: 0 33px;
		padding-top: 118px;
	}
	.point-color-area > div:before {
		height: 118px;
	}
	.point-color-area > div span {
		font-size: 16px;
	}
	.point-font-area {
		width: 980px;
		margin-bottom: 80px;
	}
	.point-font-area .img {
		width: 731px;
	}
	.point-icon-area .img {
		width: 980px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/serveone.vue